import { useState } from 'react'
import SediService from '../services/SediService/SediService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useSedi = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingSedi: false,
    isLoadingSedeCreating: false,
    isLoadingSedeDelete: false,
    isLoadingSedeUpdate: false,
    isLoadingSediByParams: false,
  });

  const [modalState, setModalState] = useState({
    showModalInfoSede: false,
    showModalCreateSede: false,
    showModalDeleteSede: false,
    showModalUpdateSede: false
  });

  const getAllSedi = async () => {
    setLoadingState({ ...loadingState, isLoadingSedi: true });
    try {
      let response = await SediService.getAllSedi();
      if (response.ok) {
        const sedi = await response.json();
        return sedi;
      }
    } catch (error) {
      alertService.error("Si è verificato un errore nel tentativo di visualizzare le sedi", {autoClose: true});
    } finally {
      setLoadingState({ ...loadingState, isLoadingSedi: false });
    }
  };

  const getSediByParams = async (params) => {
    setLoadingState({ ...loadingState, isLoadingSediByParams: true });
    try {
      let obj;
      let response = await SediService.getSediByParams(params);
      const res = await response.json();
      const totalRecord = response.headers.get('X-Total-Record');
      obj = {
        data: res,
        count: totalRecord
      }
      return obj
    } catch (err) {
      handleError(err)
    } finally {
      setLoadingState({ ...loadingState, isLoadingSediByParams: false });
    }
  }

  const createSede = async (data) => {
    setLoadingState({ ...loadingState, isLoadingSedeCreating: true });
    try {
      let response = await SediService.createSede(data);
      alertService.success("Sede creata con successo", {autoClose: true});
      setModalState({...modalState, showModalCreateSede: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingSedeCreating: false });
    }
  }

  const deleteSede = async (id) => {
    try {
      setLoadingState({ ...loadingState, isLoadingSedeDelete: true });
      let response = await SediService.deleteSede(id);
      const res = await response.json();
      alertService.success("Sede eliminata con successo", {autoClose: true});
      setModalState({...modalState, showModalDeleteSede: false });
      return res;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingSedeDelete: false });
    }
  }

  const updateSede = async (data) => {
    try {
      setLoadingState({ ...loadingState, isLoadingSedeUpdate: true });
      let response = await SediService.updateSede(data);
      alertService.success("Sede aggiornata con successo", {autoClose: true});
      setModalState({...modalState, showModalUpdateSede: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingSedeUpdate: false });
    }
  }

  return {
    getAllSedi,
    createSede,
    loadingStateSedi: loadingState,
    modalStateSedi: modalState,
    setModalStateSedi: setModalState,
    updateSede,
    deleteSede,
    getSediByParams
  };
}

export default useSedi;